// extracted by css-extract-rspack-plugin
export default {"spaceSmall":"12px","container":"language-support__container___d3dzO"};